<template>
  <v-row class="vimeoVideoBlock ">
    <v-col cols="12" lg="10" :xl="full ? 10 : 8" class="my-5">
      <vue-plyr  v-if="isRender" :emit="['playing','pause', 'ended']" @playing="$root.soundManager.mute('content')" @pause="$root.soundManager.unmute('content')" @ended="$root.soundManager.unmute('content')">
        <div data-plyr-provider="vimeo" :data-plyr-embed-id="videoId"></div>
      </vue-plyr>
    </v-col>
  </v-row>
</template>

<script>
import { Platform } from '@monogrid/js-utils'
import getVideoId from 'get-video-id'

export default {
  name: 'ContentVideoVimeoPlayer',
  props: {
    data: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      videoId: getVideoId(this.data.url).id
    }
  },

  destroyed () {
    this.$root.soundManager.unmute('content')
  },
  computed: {
    player () {
      return this.$refs.plyr.player
    },
    isRender () {
      return !Platform.prerenderer
    }
  }
}
</script>

<style scoped lang="scss">
  .vimeoVideoBlock {
    width: 100%;
    height: auto;

    ::v-deep .plyr__control--overlaid {
      background: #ffcbc4 !important;
    }

    ::v-deep input[type=range] {
      color: #ffcbc4 !important;
    }

    ::v-deep .plyr__control:hover {
      background: #ffcbc4;
    }
  }
</style>
